(function() {
  const variantImageMap = {
    // 8 Person Camping Tent | 2 Rooms
    '41292451479724': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_17f38695-594b-4104-92ad-d0c571c084f9.jpg?v=1776754253',
    '46103881908396': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_98323283-ab77-4725-b2a5-5f61a01cf3bd.jpg?v=1776754253',
    '46103881941164': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Deep_Gray.jpg?v=1776754253',
    '46103881973932': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Gray.jpg?v=1776754253',
    '46103882006700': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_1428da1a-3865-445f-a54f-3a1f989e1d81.jpg?v=1776754253',
    '46103882039468': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Light_Green.jpg?v=1776754253',
    '46103882072236': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_88630c2a-a21a-4991-bce3-a29417b62948.jpg?v=1776754253',
    '46103882105004': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_20e6abd0-49eb-414b-b684-51c9d36391a2.jpg?v=1776754253',
    // Portable Folding Camping Cot with Air Mattress
    '46103782916268': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1.jpg?v=1775198246',
    '46103782949036': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1.jpg?v=1775198246',
    '46103782981804': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/51U2TcqI9qL._AC_SL1500.jpg?v=1775198595',
    '46103783014572': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/51U2TcqI9qL._AC_SL1500.jpg?v=1775198595',
    '46103783047340': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/61ZVjhW0peL._AC_SL1500.jpg?v=1775198616',
    '46103783080108': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/61ZVjhW0peL._AC_SL1500.jpg?v=1775198616',
    '46103783112876': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/61wjEJ7iCzL._AC_SL1500_d8f8f481-2706-4535-8bf7-ee6d658d872a.jpg?v=1775198628',
    '46103783145644': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/61wjEJ7iCzL._AC_SL1500_d8f8f481-2706-4535-8bf7-ee6d658d872a.jpg?v=1775198628',
    // SUV Tailgate Tent
    '46132357562540': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_b19fb2d8-f5c1-424e-bd47-c8797427fb40.jpg?v=1775980355',
    '46132357595308': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_e2d5dc62-821f-4a43-96b7-673e6cf365bb.jpg?v=1775980718',
    // 12 Person Camping Tent | 3 Rooms
    '46137601491116': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_fca6b98b-61d7-4e56-adb1-523b3e94b585.jpg?v=1776158969',
    '46137601523884': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/617X_mUQ9uL._AC_S23L1500.jpg?v=1776159117',
    '46137601556652': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/617X_mUQ9uL._AC_SL1500.jpg?v=1776159134',
    // 4-6 Person Camping Tent | 1 Room
    '46137755664556': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_47e3e97d-613b-4289-9b17-436330391b9d.jpg?v=1776161479',
    '46137755697324': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_be73df18-0c80-484c-b51a-a13bb66335ea.jpg?v=1776161455',
    '46137755730092': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_65852c01-bca1-4867-8aa7-dc2d097da377.jpg?v=1776161494',
    '46137755762860': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/TEABLUR.jpg?v=1776161691',
    '46137755795628': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_e1a0d542-201a-48ec-8826-2a5d7287b55a.jpg?v=1776161605',
    '46137755828396': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/DGR.jpg?v=1776161678',
    // 2-4 Person Camping Tent | 1 Room
    '46138019872940': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_17bf9d35-2986-47b0-8422-4d3a2f9a9072.jpg?v=1776162024',
    '46138019905708': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Olive.jpg?v=1776162630',
    '46138019938476': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Black.jpg?v=1776162674',
    '46138019971244': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Brown.jpg?v=1776162719',
    '46138020004012': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Dark_Green.jpg?v=1776162761',
    '46138020036780': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Deep_Gray_1f7fd9b4-7025-4e69-9d06-e6fee9968ce1.jpg?v=1776162804',
    '46138020069548': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Green.jpg?v=1776162852',
    '46138020102316': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Grey.jpg?v=1776162895',
    '46138020135084': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Tea_Blue.jpg?v=1776162955',
    '46138020167852': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/tan.jpg?v=1776163008',
    // 2/4/6 Person Camping Tent Dome
    '46171344994476': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_f0ff107f-0093-4981-9f6f-9850c5858664.jpg?v=1776757632',
    '46171345027244': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Grey.webp?v=1776759087',
    '46171345060012': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Deep_Gray.webp?v=1776759087',
    '46171345092780': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/51v2mQd8xCL._AC_SL1500.webp?v=1776759087',
    '46171345125548': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Green.webp?v=1776759087',
    '46171345158316': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/51snOIwSCpL._AC_SL1500.webp?v=1776759087',
    '46171345191084': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/61tEIkqq8NL._AC_SL1500.webp?v=1776759087',
    '46171345223852': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/6135y7sBxeL._AC_SL1500.webp?v=1776759087',
    // 6/8 Person Family Camping Tent Dome
    '46171384152236': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_c18e6187-d496-4c54-a190-29617df1398b.webp?v=1776759916',
    '46171384185004': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/61pujCvTIKL._AC_SL1500.webp?v=1776759916',
    '46171384217772': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Gray.webp?v=1776759917',
    '46171384250540': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/DarkGray.webp?v=1776759917',
    '46171384283308': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Olive.webp?v=1776759916',
    '46171384316076': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/61x3ez5ELqL._AC_SL1500.webp?v=1776759916',
    // 3 Person Lightweight Backpacking Tent
    '46171405385900': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/51Lz0b8Z_PL._AC_SL1274.webp?v=1776760351',
    '46171405418668': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/51hg7n6p16L._AC_SL1500.webp?v=1776760351',
    // 12 Person Extra Large Family Cabin Tent
    '46171410399404': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/image_1_6bbe16f2-3ffa-4e7d-b1ae-1d67c53f1048.webp?v=1776760726',
    // Replacement Canopy Top
    '46178611658924': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Khaki.webp?v=1776927057',
    '46178611527852': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/NavyBlue.webp?v=1776927057',
    '46178611560620': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Black.webp?v=1776927057',
    '46178611593388': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/DarkGrey.webp?v=1776927057',
    '46178611626156': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Green_5fc00fad-9a1b-431a-a888-0f6f7b719ebc.webp?v=1776927057',
    '46178611691692': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/LightBlue.webp?v=1776927057',
    '46178611724460': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/LightGray.webp?v=1776927057',
    '46178611757228': 'https://cdn.shopify.com/s/files/1/0613/9478/0332/files/Red.webp?v=1776927058',
  };

  function initSwatches() {
    document.querySelectorAll('fieldset[data-fieldset-index]').forEach(function(fieldset) {
      const legend = fieldset.querySelector('legend');
      if (!legend) return;
      if (!/color|颜色|colour/i.test(legend.textContent)) return;
      if (fieldset.dataset.swatchDone) return;
      fieldset.dataset.swatchDone = 'true';

      if (!document.getElementById('cp-swatch-style')) {
        const s = document.createElement('style');
        s.id = 'cp-swatch-style';
        s.textContent = `
          .cp-legend-wrap { display:block; margin-bottom:8px; }
          .cp-legend-line { display:flex; align-items:center; gap:6px; font-size:14px; font-weight:500; margin-bottom:8px; }
          .cp-legend-value { color:#000; }
          .cp-swatch-row { display:flex; flex-wrap:wrap; gap:8px; }
          .cp-swatch-item { position:relative; cursor:pointer; }
          .cp-swatch-item input { position:absolute; opacity:0; width:0; height:0; }
          .cp-swatch-item img { width:84px; height:84px; object-fit:cover; border-radius:4px; border:2px solid transparent; display:block; }
          .cp-swatch-item span.no-img { width:84px; height:84px; border-radius:4px; border:2px solid #ccc; display:flex; align-items:center; justify-content:center; font-size:11px; color:#333; text-align:center; padding:4px; box-sizing:border-box; }
          .cp-swatch-item input:checked ~ img { border-color:#000; box-shadow:0 0 0 1px #000; }
          .cp-swatch-item input:checked ~ span.no-img { border-color:#000; box-shadow:0 0 0 1px #000; }
          .cp-swatch-item:hover img { border-color:#888; }
          .cp-swatch-item.unavailable img { opacity:0.35; }
        `;
        document.head.appendChild(s);
      }

      legend.style.display = 'none';

      const legendWrap = document.createElement('div');
      legendWrap.className = 'cp-legend-wrap';

      const legendLine = document.createElement('div');
      legendLine.className = 'cp-legend-line';

      const legendName = document.createElement('span');
      legendName.textContent = legend.textContent.trim().replace(/\s*:.*$/, '') + ':';

      const legendValue = document.createElement('span');
      legendValue.className = 'cp-legend-value';

      legendLine.appendChild(legendName);
      legendLine.appendChild(legendValue);
      legendWrap.appendChild(legendLine);

      const row = document.createElement('div');
      row.className = 'cp-swatch-row';

      fieldset.querySelectorAll('label').forEach(function(label) {
        const input = label.querySelector('input[type=radio]');
        if (!input) return;

        const variantId = input.dataset.variantId;
        const colorName = input.value;
        const available = input.dataset.optionAvailable !== 'false';
        const imgSrc = variantImageMap[variantId] || '';

        const item = document.createElement('label');
        item.className = 'cp-swatch-item' + (available ? '' : ' unavailable');
        item.title = colorName;

        const clonedInput = input.cloneNode();
        clonedInput.addEventListener('change', function() {
          input.checked = true;
          input.dispatchEvent(new Event('change', {bubbles: true}));
          legendValue.textContent = colorName;
        });
        item.appendChild(clonedInput);

        if (imgSrc) {
          const img = document.createElement('img');
          img.src = imgSrc;
          img.alt = colorName;
          item.appendChild(img);
        } else {
          const span = document.createElement('span');
          span.className = 'no-img';
          span.textContent = colorName;
          item.appendChild(span);
        }

        if (input.checked) legendValue.textContent = colorName;

        row.appendChild(item);
      });

      legendWrap.appendChild(row);
      fieldset.querySelectorAll('label').forEach(l => l.style.display = 'none');
      fieldset.insertBefore(legendWrap, fieldset.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatches);
  } else {
    initSwatches();
  }

  new MutationObserver(initSwatches).observe(document.body, {childList:true, subtree:true});
})();
